import { Outlet, NavLink } from 'react-router-dom';
import { useAdmin } from '../../hooks/useAdmin';
import AdminRoute from '../Auth/AdminRoute';
import NotificationContainer from '../Notifications/NotificationContainer';

export default function AdminLayout() {
  const { currentUser } = useAdmin();

  return (
    <AdminRoute>
      <div className="min-h-screen theme-surface">
        <NotificationContainer />
        {/* Admin Header */}
        <div className="border-b border-gray-200 dark:border-gray-700 theme-card">
          <div className="max-w-7xl mx-auto px-6 py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-2">
                  <div className="p-2 bg-red-100 dark:bg-red-900 rounded-lg">
                    <svg className="h-6 w-6 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                    </svg>
                  </div>
                  <div>
                    <h1 className="text-xl font-bold theme-text">Chime Admin</h1>
                    <p className="text-xs theme-text-muted">Administrative Control Panel</p>
                  </div>
                </div>
                
                {/* Admin Navigation */}
                <nav className="hidden md:flex space-x-6">
                  <NavLink
                    to="/admin"
                    end
                    className={({ isActive }) =>
                      `px-3 py-2 text-sm font-medium transition-colors rounded-md ${
                        isActive
                          ? 'bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300'
                          : 'theme-text hover:theme-text-hover hover:bg-gray-100 dark:hover:bg-gray-700'
                      }`
                    }
                  >
                    Dashboard
                  </NavLink>
                  <NavLink
                    to="/admin/users"
                    className={({ isActive }) =>
                      `px-3 py-2 text-sm font-medium transition-colors rounded-md ${
                        isActive
                          ? 'bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300'
                          : 'theme-text hover:theme-text-hover hover:bg-gray-100 dark:hover:bg-gray-700'
                      }`
                    }
                  >
                    Users
                  </NavLink>
                  <NavLink
                    to="/admin/online"
                    className={({ isActive }) =>
                      `px-3 py-2 text-sm font-medium transition-colors rounded-md ${
                        isActive
                          ? 'bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300'
                          : 'theme-text hover:theme-text-hover hover:bg-gray-100 dark:hover:bg-gray-700'
                      }`
                    }
                  >
                    Who's Online
                  </NavLink>
                  <NavLink
                    to="/admin/notifications"
                    className={({ isActive }) =>
                      `px-3 py-2 text-sm font-medium transition-colors rounded-md ${
                        isActive
                          ? 'bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300'
                          : 'theme-text hover:theme-text-hover hover:bg-gray-100 dark:hover:bg-gray-700'
                      }`
                    }
                  >
                    Notifications
                  </NavLink>
                  <NavLink
                    to="/admin/reconstruction-webhook"
                    className={({ isActive }) =>
                      `px-3 py-2 text-sm font-medium transition-colors rounded-md ${
                        isActive
                          ? 'bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300'
                          : 'theme-text hover:theme-text-hover hover:bg-gray-100 dark:hover:bg-gray-700'
                      }`
                    }
                  >
                    Webhook
                  </NavLink>
                  <NavLink
                    to="/admin/logs"
                    className={({ isActive }) =>
                      `px-3 py-2 text-sm font-medium transition-colors rounded-md ${
                        isActive
                          ? 'bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300'
                          : 'theme-text hover:theme-text-hover hover:bg-gray-100 dark:hover:bg-gray-700'
                      }`
                    }
                  >
                    Server Logs
                  </NavLink>
                  <NavLink
                    to="/admin/phi-settings"
                    className={({ isActive }) =>
                      `px-3 py-2 text-sm font-medium transition-colors rounded-md ${
                        isActive
                          ? 'bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300'
                          : 'theme-text hover:theme-text-hover hover:bg-gray-100 dark:hover:bg-gray-700'
                      }`
                    }
                  >
                    PHI Detection
                  </NavLink>
                </nav>
              </div>

              {/* Admin User Info */}
              <div className="flex items-center space-x-4">
                <div className="text-right">
                  <p className="text-sm font-medium theme-text">
                    {currentUser?.fullName || currentUser?.username}
                  </p>
                  <p className="text-xs theme-text-muted">Admin</p>
                </div>
                <div className="h-8 w-8 bg-red-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-sm font-medium">
                    {(currentUser?.fullName || currentUser?.username || 'A').charAt(0).toUpperCase()}
                  </span>
                </div>
                <NavLink
                  to="/"
                  className="px-3 py-2 text-sm font-medium theme-text hover:theme-text-hover transition-colors rounded-md hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  ← Back to App
                </NavLink>
              </div>
            </div>
          </div>
        </div>

        {/* Admin Content */}
        <main className="min-h-screen bg-gray-50 dark:bg-gray-900">
          <Outlet />
        </main>
      </div>
    </AdminRoute>
  );
}